export default {
    'en': 'English',
    'pl': 'Polski',
    'ru': 'Русский',
    'FIWE_FEVER': 'FIWE FEVER',
    'EXPERIENCE': 'Попробуйте Justfit EMS на',
    'FIWE': 'FIWE',
    'DATE': 'Варшава 13.09.2019 - 15.09.2019.<br> Стенд Justfit: зал IV. стенд 4.20',
    'YOUTUBE_TEXT': 'Смотрите видео на Youtube',
    'SAVE_IT': 'Сэкономьте 5,000 евро, и ваш EMS бизнес ракетой взлетит до небес',
    'JUSTFIT_LITE_PRICE': 'Топовый продукт EMS JustfitPro+ в многопользовательском варианте доступен по цене проводной системы.',
    'CONCEPT': 'С приобретением JustfitPro+ вы получаете не только продукт, а становитесь участником программы наставничества Justfit. Вы будете пользоваться преимуществами нашей поддержки, как в бизнесе, так и технологической сфере.    ',
    'SYSTEM': 'JustfitPro+ — это открытая система, предназначенная для многопользовательской работы. Последующие расширения вы получите с экстра-скидкой.',
    'SERVICE': 'Мы обеспечиваем польское представительство, польский сервис и польскую поддержку.',
    'CUSTOMIZED_PRODUCT': 'Получите адаптированную для вас конфигурацию продукта и схему бизнеса в соответствии с вашими потребностями.',
    'APPOINTMENT': 'Подумайте о будущем, запишитесь на тестовый тренинг Justfit на FIWE.',
    'INTERESTED': "ДА, меня интересует",
    'JUSTFIT_EXPERIENCE': 'ПОПРОБУЙТЕ JUSTFIT НА FIWE',
    'TRAININGS': 'Примите участие в индивидуальном или небольшом групповом тестовом тренинге',
    'TRAININGS_TEXT': 'С 10:00 до 16:00 каждый час мы проводим тестовый тренинг на нашем стенде – Зал IV. стенд 4.20. Запишитесь внизу страницы и зарезервируйте себе место!',
    'PRESENTATION': 'Попросите персональную презентацию продукта',
    'PRESENTATION_TEXT': 'Запишитесь в нижней части страницы на персональную презентацию продукта и узнайте об уникальных возможностях для бизнеса.',
    'FORM_TITLE': 'ЗАПИШИТЕСЬ НА СЕАНС',
    'FORM_TEXT': 'Зарезервируйте себе место на одном из тестовых занятий Justfit или запросите персональную презентацию продукта, заполнив форму ниже. Добро пожаловать на наш стенд: зал IV. стенд 4.20.',
    'CONTACT_TEXT': 'Если у вас имеются какие-либо вопросы, пожалуйста, свяжитесь с нами:',
    'YOUR_NAME': 'Имя',
    'EMAIL': 'Email адрес',
    'MESSAGE': 'Сообщение',
    'SUBMIT_TEXT': 'Отправить запрос',
	"SENT_FORM": "Спасибо за регистрацию, добро пожаловать!",
    "ERROR_SENT_FORM": "Something went wrong, please try again",
    'TRAINING_TYPE': 'Меня интересует индивидуальное и групповое занятие',
    'PRESENTATION_TYPE': 'Я хотел бы принять участие в персональной презентации',
    'PREFERRED_DAY': 'Предпочтительный день посещения:',
    'DAY_1': 'Пятница 13.09.2019.',
    'DAY_2': 'Суббота 14.09.2019.',
    'DAY_3': 'Воскресенье 15.09.2019.',
    'PREFERRED_TIME': 'Предпочтительное время посещения:',
    'TIME_1': '8:00-12:00',
    'TIME_2': '12:00-16:00',
    'TIME_3': '17:00-20:00',
    'AGREE': 'Я ознакомился и принимаю Заявление о <a class="font-style-italic font-weight-semibold" target="_blank" href="https://justfitart.com/images/privacypolicy.pdf">конфиденциальности</a>.',
    'YOU_NEED_TO_AGREE': 'You need to agree the privacy policy',
    'LINK_TO_PRODUCT': 'Нажмите здесь, чтобы зарезервировать свой продукт со скидкой',
    'JUSTFITPRO_PRICE': 'JustfitPro+ только за <span class="font-weight-heavy fs-40">12,500</span> евро на FIWE <br> <span class="font-weight-normal fs-14">(сейчас Вы сэкономите 5000 евро)</span>',
}
